import React, { createContext, useState, useEffect } from 'react';
import * as ReactGA from 'react-ga';
import { useParams } from 'react-router-dom';
import { 
  DeluxeLayout,
} from './';

export const DeluxeContext = createContext({});

export const Deluxe = () => {
  const params = useParams();
  const { periodParam } = params;

  const setPeriod = 
    periodParam === 'month' || periodParam === 'maand' 
      ? 'month'
      : 'year';
      
  const [currentSelection, setCurrentSelection] = useState({
    page: 'features', // features, feature, payment, thanks, terms
    feature: null, // Selected featured
    payment: {
      period: setPeriod, // 'year', 'month'
      frequency: null, // 1, 2, 3
      prices: {
        action: '2,99',
        retail: '4,99',
      },
    },
  }); 

  const { page, payment: { period } } = currentSelection;

  const GAEvent = event => {
    ReactGA.event({
      category: 'Premium beta test',
      ...event,
    });
  };

  const surveyLink = event => {
    if (event) {
      GAEvent(event);
    }   
    const href = () => {
      switch (page) {
      case 'payment':
        return period === 'month'
          ? 'https://surveys.hotjar.com/b131ea05-36ed-4d7a-aa2a-c6b84416c2c4'
          : 'https://surveys.hotjar.com/916ab446-b6d6-47fc-a5d2-0d7347c6ea4c';
      case 'features':
        return 'https://surveys.hotjar.com/21957c98-cd4a-4f43-aae1-c01448d52678';
      default:
        return;
      }
    }; 
    window.open(href(), '_blank', 'noopener, noreferrer');
  };

  const goToPage = (page, event) => {
    setCurrentSelection({
      ...currentSelection,
      page: page,
    });
    if (event) {
      GAEvent(event);
    }
  };

  const dumpertButtonHandler = () => {
    GAEvent({
      action: page === 'features' ? 'FeatureOverviewPage' : 'ThankYouPage',
      label: 'BackToDumpert',
    });
  };

  const featureCardHandler = title => {
    setCurrentSelection({
      ...currentSelection,
      page: 'feature',
      feature: title,
    });
    GAEvent({
      action: 'FeatureOverviewPage',
      label: title,
    });    
  };

  const selectionHandler = frequency => {
    frequencySelectHandler(frequency);
    GAEvent({
      action: 'PaymentPageYearly',
      label: `${frequency} year`,
    });
  };

  const backButtonHandler = () => {
    const eventAction = () => {
      switch(page) {
      case 'payment':
        return `PaymentPage${period.charAt(0).toUpperCase() + period.slice(1)}ly`;
      case 'feature':
        return 'FeaturePage';
      case 'terms':
        return `Terms${period.charAt(0).toUpperCase() + period.slice(1)}ly`;
      }
    };

    GAEvent({
      action: eventAction(),
      label: 'BackButton',
    });

    goToPage(page === 'terms' ? 'payment' : 'features');
  };     

  const exitButtonHandler = () => {
    const eventAction = () => {
      const setPage = `${page.charAt(0).toUpperCase() + page.slice(1)}Page`;
      switch (page) {
      case 'payment':
        return `${setPage}${ period.charAt(0).toUpperCase() + period.slice(1) }ly`;
      case 'features':
        return 'FeatureOverview';
      default:
        return setPage;
      }
    };

    surveyLink({
      action: eventAction(),
      label: 'ExitButton',
    });
  };

  const frequencySelectHandler = frequency => {
    setCurrentSelection({
      ...currentSelection,
      payment: {
        ...currentSelection.payment,
        frequency: frequency,
        prices: {
          ...currentSelection.payment.prices,
          action: frequency === 3 ? '1,99' : '2,99',
        },
      },
    });
  };
  
  const onClickHandlers = { 
    surveyLink, 
    goToPage, 
    GAEvent,
    dumpertButtonHandler,
    backButtonHandler, 
    exitButtonHandler,
    featureCardHandler,
    selectionHandler,
    frequencySelectHandler, 
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <DeluxeContext.Provider value={{
      currentSelection,
      setCurrentSelection,
      onClickHandlers,
    }}>
      <DeluxeLayout />
    </DeluxeContext.Provider>
  );
};